/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Floating_Minimize_DialogInputs */



/**
* | output |
* | --- |
* | "Minimize dialog" |
*
* @param {Spaces_Floating_Minimize_DialogInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_floating_minimize_dialog = /** @type {((inputs?: Spaces_Floating_Minimize_DialogInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Floating_Minimize_DialogInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialog minimieren")
	return /** @type {LocalizedString} */ ("Minimize dialog")
});